import toast from "react-hot-toast";
import Happy from "../../assets/svg/Happy";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

export const CreateListingNotice = ({ handleClose }) => {
  const [hidden, setHidden] = useState(false);

  const merchant = useSelector(
    (state) => state.auth.account_info.merchant_info
  );
  const navigate = useNavigate();
  const handleCreateListing = () => {
    if (merchant?.status !== "1") {
      navigate("/merchant/listing/new");
      handleClose();
    } else {
      toast.dismiss();
      toast(
        "Your application is now subject for verification. Please wait for confirmation"
      );
    }
  };

  const handleDoLater = () => {
    sessionStorage.setItem("createListingNoticeDismissed", "true");
    setHidden(true);
    handleClose();
  };

  if (hidden) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-xs">
      <div className="bg-white rounded-lg max-w-md w-full mx-4 p-6 relative overflow-y-auto max-h-[90vh]">
        <div className="flex flex-col items-center space-y-8">
          <Happy className="w-full max-w-xs" />
          <div className="text-center">
            <h2 className="text-lg font-semibold">Join the Momentum!</h2>
            <p className="text-sm mt-2" style={{ color: "#4B5563" }}>
              Just a quick reminder to create your listing so customers can find
              and book you. Listings are already getting views—hop in while the
              momentum’s hot!
            </p>
          </div>
        </div>
        <div className="mx-4 mt-8 flex space-x-2">
          <button
            className="flex-1 py-3 font-semibold text-sunrise-500 bg-white"
            onClick={handleDoLater}
          >
            Do it later
          </button>
          <button
            className="flex-1 py-3 rounded-xl bg-primary-500 text-white font-semibold hover:opacity-90"
            onClick={handleCreateListing}
          >
            Create Listing
          </button>
        </div>
      </div>
    </div>
  );
};
